import { SET_BASE_CURRENCIES } from "./type";

export const setBaseCurrencies = (currencies) => {
  return {
    type: SET_BASE_CURRENCIES,
    currencies: currencies,
  };
};
